import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { manualRejectForwardDraw } from "@services/administrativeApprovals";

export const useManualRejectForwardDraw = (
  options: Record<string, any> = {}
) => {
  const { onSuccess, ...restOptions } = options;
  const queryClient = useQueryClient();

  return useMutation(manualRejectForwardDraw, {
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ["administrativeApprovals"],
      });

      if (isFunction(onSuccess)) {
        onSuccess(res);
      }
    },
    ...restOptions,
  });
};
